<template>
  <div class="login-container">
    <img src="/static/images/logo2.png" class="login-logo">
    <div class="login-content">
      <div class="back"></div>
      <input type="password" style="opacity: 0;" />
      <div class="form">
        <div class="title">Teamface 管理后台</div>
        <el-input placeholder="账户" v-model="input21">
          <i slot="prefix" class="el-input__icon iconfont icon-user"></i>
        </el-input>
        <div class="err" :style="{opacity: err21 ? 1 : 0}"><i class="el-icon-warning"></i>{{err21 || '2'}}</div>
        <el-input placeholder="密码" v-model="input22" type="password" @keyup.enter.native="loginUser">
          <i slot="prefix" class="el-input__icon iconfont icon-password"></i>
        </el-input>
        <div class="err" :style="{opacity: err22 ? 1 : 0}"><i class="el-icon-warning"></i>{{err22 || '1'}}</div>
        <el-checkbox v-model="checked">记住密码</el-checkbox>
        <div class="login" @click="loginUser">登 录</div>
      </div>
    </div>
    <img src="/static/images/line01.png" class="line1">
    <img src="/static/images/line02.png" class="line2">
    <img src="/static/images/line03.png" class="line3">
    <img src="/static/images/line04.png" class="line4">
    <footer>
      <div>Copyright © 2018 TeamFace</div>
    </footer>
  </div>
</template>
<script>
import md5 from 'js-md5'
import {regular, TFParameter} from '@/common/js/constant.js'
import {HTTPServer} from '@/common/js/ajax.js'
export default {
  data () {
    return {
      defaultMsg: '<b>登录界面</b>',
      input21: '',
      // ad: '13008811115',
      input22: '',
      err21: '',
      err22: '',
      cookieUserName: 'TEAMFACE_SERVICE_LOGIN_ACCOUNT',
      cookieUserPwd: 'TEAMFACE_SERVICE_LOGIN_PASSWORD',
      checked: true
    }
  },
  mounted () {
    sessionStorage.requestHeader = JSON.stringify({'CLIENT_FLAG': '0'})
    var user = localStorage.getItem(this.cookieUserName)
    if (user) {
      user = JSON.parse(user)
      this.input21 = user[this.cookieUserName]
      this.input22 = (this.b64DecodeUnicode(this.b64DecodeUnicode(user[this.cookieUserPwd]))).substring(16)
      var d7 = 7 * 24 * 60 * 60 * 1000
      if ((new Date().getTime()) - user.D7 > d7) {
        localStorage.removeItem(this.cookieUserName)
      }
    }
  },
  methods: {
    /** 登录 */
    loginUser () {
      this.err21 = ''
      this.err22 = ''
      if (!this.input21) {
        this.err21 = '手机号不能为空!'
        return false
      } else if (!regular.phone.test(this.input21)) {
        this.err21 = '您输入的手机号格式不正确!'
        return false
      } else if (!this.input22) {
        this.err22 = '密码不能为空!'
        return false
      }
      var jsondata = {
        userName: this.input21,
        passWord: md5(md5(this.input22 + TFParameter.TEAMFACEPWD))
      }
      HTTPServer.login(jsondata, 'Loading').then((res) => {
        // 缓存附件图片的ip地址信息
        sessionStorage.setItem('pictureAttachmentDomain', res.domain)
        sessionStorage.requestHeader = JSON.stringify({'TOKEN': res.token})
        sessionStorage.userInfo = JSON.stringify(res)
        if (this.checked) {
          var obj = {'D7': new Date().getTime()}
          obj[this.cookieUserName] = this.input21
          obj[this.cookieUserPwd] = this.b64EncodeUnicode(this.b64EncodeUnicode(TFParameter.TEAMFACEPWD + this.input22))
          localStorage.setItem(this.cookieUserName, JSON.stringify(obj))
        }
        this.$router.push({name: 'Formal'})
      })
    },
    /** 加密 */
    b64EncodeUnicode (str) {
      return btoa(encodeURIComponent(str).replace(/%([0-9A-F]{2})/g, function (match, p1) {
        return String.fromCharCode('0x' + p1)
      }))
    },
    /** 解密 */
    b64DecodeUnicode (str) {
      return decodeURIComponent(atob(str).split('').map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
      }).join(''))
    }
  }
}
</script>

<style scoped lang="scss">
.login-container{
  height: 100%;
  position: relative;
  .login-logo{
    margin: 50px 0 0 50px;
  }
  .login-content{
    background: #05070c url(/static/images/login-banner.jpg) 50% 50% no-repeat;
    height: 400px;
    background-size: cover;
    position: absolute;
    top: calc(50% - 260px);
    width: 100%;
    .back{
      width: 460px;
      height: 310px;
      position: absolute;
      z-index: 1;
      left: calc(50% - 230px);
      top: 45px;
      background: rgba(255,255,255,0.80);
      box-shadow: 0 2px 20px 0 rgba(0,0,0,0.10);
    }
    .form{
      width: 268px;
      height: 310px;
      position: absolute;
      z-index: 1;
      left: calc(50% - 1730px);
      top: 0;
      box-sizing: content-box;
      border-left: 1500px solid rgba(54, 73, 104, .3);
      border-right: 1500px solid rgba(54, 73, 104, .3);
      border-top: 45px solid rgba(54, 73, 104, .3);
      border-bottom: 45px solid rgba(54, 73, 104, .3);
      padding: 0 96px;
      .title{
        font-size: 18px;
        color: #424242;
        margin: 30px 0 15px;
        text-align: center;
      }
      .err{
        font-size: 12px;
        color: #EB3F23;
        line-height: 18px;
        i{
          font-size: 12px;
          float: left;
          margin: 4px 4px 0 10px;
        }
      }
      .el-checkbox{
      }
      .login{
        display: inline-block;
        background: #0A7FEC;
        border-radius: 4px;
        width: 100%;
        height: 40px;
        text-align: center;
        line-height: 40px;
        color: #fff;
        cursor: pointer;
        margin-top: 20px;
      }
    }
  }
  .line1{
    position: absolute;
    left: 210px;
    top: calc(50% - 450px);
  }
  .line2{
    position: absolute;
    left: calc(50% + 180px);
    top: calc(50% - 380px);
  }
  .line3{
    position: absolute;
    left: 160px;
    top: calc(50% + 220px);
  }
  .line4{
    position: absolute;
     left: calc(50% + 40px);
    top: calc(50% + 140px);
  }
  footer{
    position: absolute;
    bottom: 20px;
    width: 100%;
    div{
      width: 100%;
      max-width: 900px;
      margin: 0 auto;
      text-align: left;
      font-size: 14px;
      color: #A0A0AE;
      padding: 0 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/login/login.vue